import React from 'react';

import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useGetFulfillmentPlanDataForRestore } from '../../../../../hooks/entities/selectors/fulfillment-plans';
import { RestoreCancelledDropdownMenuItem } from '../../../../../components/restore/restore-cancelled-dropdown-menu-item';
import { RestoreShippedDropdownMenuItem } from '../../../../../components/restore/restore-shipped-dropdown-menu-item';
import { FulfillmentPlanOrderGridStatus } from '../../../../../enums/fulfillmentplan-order-grid-status';

export const RestoreShipmentMenuItem = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { orderGridStatus } = useGetFulfillmentPlanDataForRestore(fulfillmentPlanId);
  // we only want to allow restore for shipments that have been imported as shipped which means there is no fulfillmentId
  // and the status of the shipment needs to be restorable

  if (orderGridStatus === FulfillmentPlanOrderGridStatus.Cancelled.name) {
    return <RestoreCancelledDropdownMenuItem fulfillmentPlanId={fulfillmentPlanId} />;
  }
  return <RestoreShippedDropdownMenuItem fulfillmentPlanId={fulfillmentPlanId} />;
};
